<template>
    <div>
        <div class="col-12 float-right p-0">
            <a :href="reports_list_route">
                <button class="btn btn-default float-left" type="button">{{ $lang('Wróć') }}</button>
            </a>
        </div>

        <form id="reportForm" class="mb-5 mt-4">
            <tasks-by-client-inputs v-on:validation="validation" :libraries="libraries"></tasks-by-client-inputs>
            <div class="row col-12 justify-content-end px-0 mx-0">
                <button class="btn btn-primary mt-3" type="button" @click="generate(1, report_id)"
                        :disabled="validForm === false">{{$lang('Generuj')}}
                </button>
            </div>
        </form>
        <div v-if="showTable===true">
            <tasks-by-client-table id="reportTable" :pagination="pagination" :criteria="criteriaCounter"
                                   :statuses="statusesCounter" :jira_link="jira_link" :ptd_link="ptd_link"
                                   :project_badge_prefix="project_badge_prefix" :with_comments="withComments"
            ></tasks-by-client-table>
            <button class="pull-right btn btn-primary ml-3 mt-3 mb-3" type="button" v-on:click="exportPDF()"
                    :disabled="!hasData()">
                {{$lang('Eksport do PDF')}}
            </button>
            <button class="float-right btn btn-primary mt-3 mb-3" type="button" v-on:click="exportExcel()"
                    :disabled="!hasData()">
                {{$lang('Eksport do XLSX')}}
            </button>
        </div>
        <generating-modal></generating-modal>
    </div>
</template>

<script>
import ReportMethods from "../../../mixins/reports";
import GeneratingModal from "../../generating-modal";

export default {
    name: 'tasks-by-client-template',
    components: {GeneratingModal},
    mixins: [ReportMethods],
    props: {
        jira_link: String,
        ptd_link: String,
        libraries: Array
    },
    data() {
        return {
            statusesCounter: [],
            criteriaCounter: [],
            withComments: false
        }
    }
}
</script>
